import {TableColumnType} from "../../../enums/table-column-type";
import {TableColumn} from "../../../interfaces/table/table-column";
import {TemplateRef} from "@angular/core";

export enum RentalAssetTableColumn {
  SerialNumber = 'serial_number',
  AssetModel = 'full_asset_model',
  Location = 'location',
  OwnerCustomerName = 'owner_customer_name',
  LastPm = 'last_pm',
  NextPm = 'next_pm',
  RentalStartDate = 'rental_start_date',
  RentalEndDate = 'rental_end_date',
}

export function constructRentalColumns(
  serialNumberColumnTmp: TemplateRef<any>
): TableColumn[] {
  return [
    {
      columnId: RentalAssetTableColumn.SerialNumber,
      header: 'Serial Number',
      type: TableColumnType.Template,
      template: serialNumberColumnTmp,
      sortable: true
    },
    {
      columnId: RentalAssetTableColumn.AssetModel,
      header: 'Make / Model / Type',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: RentalAssetTableColumn.Location,
      header: 'Location',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: RentalAssetTableColumn.OwnerCustomerName,
      header: 'Rented From',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: RentalAssetTableColumn.LastPm,
      header: 'Last Service',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: RentalAssetTableColumn.NextPm,
      header: 'Next Service',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: RentalAssetTableColumn.RentalStartDate,
      header: 'Rental Start',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: RentalAssetTableColumn.RentalEndDate,
      header: 'Rental End',
      type: TableColumnType.Text,
      sortable: true
    }
  ];
}
